export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-secondary-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="font-heading text-xl text-background-50 mb-4">91吃瓜</h3>
            <p className="text-sm text-secondary-300 leading-relaxed">
              91吃瓜官方网站入口大全，为吃瓜群众提供91吃瓜网、91吃瓜在线、91吃瓜官网等最新地址导航，快速访问吃瓜平台主页、网页版与在线入口，一站直达热门娱乐资讯与八卦爆料。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              {[
                { label: '热门话题', href: '#topics' },
                { label: '专题汇总', href: '#index' },
                { label: '焦点深扒', href: '#carousel' },
                { label: '手机入口', href: '#app' },
                { label: '视频集锦', href: '#media' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="block text-sm text-secondary-300 hover:text-primary-400 transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4">更多服务</h4>
            <div className="space-y-2.5">
              {[
                { label: '吃瓜常见问题', href: '#faq' },
                { label: '投稿与爆料', href: '#contact' },
                { label: '关于我们', href: '#about' },
                { label: '热度排行榜', href: '#ranking' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="block text-sm text-secondary-300 hover:text-primary-400 transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-secondary-300 leading-relaxed">
              感谢各位合作伙伴的支持与信任。如有合作意向，欢迎通过投稿通道联系我们。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 91吃瓜 — 最新娱乐热点导航平台
          </p>
          <p className="text-xs text-secondary-400">
            本站内容仅作导航参考，不存储任何用户数据
          </p>
        </div>
      </div>
    </footer>
  );
}